import React, { useEffect, useState } from "react";
import {
  PartialDentureForm,
  PartialDentureProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";
import SelectInput from "../formComp/SelectInputOld";
import ToothSelector from "../formComp/ToothSelectorOld";

const PartialDenture: React.FC<PartialDentureProps> = ({ onChange }) => {
  const [form, setForm] = useState<PartialDentureForm>({
    teethReplaced: [],
    teethExtracted: [],
    desiredOutput: "",
    finishedProduct: "",
    modelNeeded: "",
    additionalNotes: "",
    shade: "",
  });

  const handleToothClick = (
    type: "teethReplaced" | "teethExtracted",
    tooth: number
  ) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof PartialDentureForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="font-bold mb-4 border-b-2 border-[#2fa9bf]">
        LDP PARTIAL DENTURE
      </h2>

      <div className="w-[100%] md:w-[90%]">
        {/* Teeth to be replaced */}
        <div className="mb-2 flex">
          <label className="block mb-2 w-[35%]">
            Teeth to be replaced<span className="text-red-500">*</span>
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.teethReplaced}
              onToothClick={(tooth) => handleToothClick("teethReplaced", tooth)}
            />
          </div>
        </div>

        {/* Teeth to be extracted */}
        <div className="mb-2 flex">
          <label className="block mb-1 w-[35%]">
            Teeth to be extracted{" "}
            <span className="text-gray-500 text-sm"> Optional</span>
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.teethExtracted}
              onToothClick={(tooth) =>
                handleToothClick("teethExtracted", tooth)
              }
            />
          </div>
        </div>

        {/* Desired output */}
        <SelectInput
          label="Desired output"
          name="desiredOutput"
          value={form.desiredOutput}
          onChange={(e) => handleChange("desiredOutput", e.target.value)}
          options={[
            { value: "Monoblock", label: "Monoblock" },
            {
              value: "Separate gingiva and teeth",
              label: "Separate gingiva and teeth",
            },
            {
              value: "both",
              label: "Both",
            },
          ]}
        />

        {/* Finished product */}
        <SelectInput
          optional
          label="Finished product"
          name="finishedProduct"
          value={form.finishedProduct}
          onChange={(e) => handleChange("finishedProduct", e.target.value)}
          options={[
            { value: "Print only", label: "Print only" },
            { value: "Print, fuse & cure", label: "Print, fuse & cure" },
            {
              value: "Print, fuse, cure & finish",
              label: "Print, fuse, cure & finish",
            },
          ]}
        />

        {/* Is 3D model needed? */}
        <SelectInput
          optional
          label="Is 3D model needed?"
          name="modelNeeded"
          value={form.finishedProduct}
          onChange={(e) => handleChange("modelNeeded", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        {/* Shade */}
        <TextInput
          optional
          label="Shade"
          name="shade"
          value={form.shade}
          onChange={(e) => handleChange("shade", e.target.value)}
        />

        {/* Additional notes */}
        <TextInput
          optional
          label="Additional notes"
          name="additionalNotes"
          value={form.additionalNotes}
          onChange={(e) => handleChange("additionalNotes", e.target.value)}
        />
      </div>
    </div>
  );
};

export default PartialDenture;
